var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import dayjs from 'dayjs';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics, BaseModel, BasesController } from '../../libraries';
let ProtocolController = class ProtocolController extends BasesController {
    constructor() {
        super();
        this.Model = new BaseModel({ type: 'object' });
        this.reset({
            dataKey: 'id',
            infinite: true,
            pagination: EnumAPI.legal_portal_protocol_userLog_findForPage,
            paginationParams: {
                currentKey: 'curPageNo',
                pageSizeKey: 'pageSize',
                response: {
                    total: 'total',
                    dataSource: 'records',
                    valueGetter: this.valueGetter,
                },
            },
        });
    }
    // browser: 'Chrome 13/136.0.0.0',
    // createBy: 'system',
    // createTime: '2025-05-13T18:12:41',
    // delFlag: 0,
    // id: '233cba25237c41db966e0bcf4cfb8b90',
    // ip: '10.112.109.31',
    // modifyBy: 'system',
    // modifyTime: '2025-05-13T18:12:41',
    // platform: 'pc',
    // protocolName: '隐私条款',
    // remarks: null,
    // sceneCode: 'login',
    // sceneName: '登录',
    // userCode: 'K0403355',
    // versionName: 'v1.0',
    valueGetter(res) {
        const dataSource = lodash.get(res, 'data').map((item) => {
            const perItem = [];
            perItem.push({
                label: '协议名称',
                value: item.protocolName + `(${item.versionName})`,
                isTitle: true,
            });
            perItem.push({ label: '场景名称', value: item.sceneName });
            perItem.push({
                label: '创建时间',
                value: dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
            });
            perItem.push({ label: '客户端', value: item.platform });
            perItem.push({ label: '用户账号', value: item.userCode });
            perItem.push({ label: '用户IP', value: item.ip });
            perItem.push({ label: '浏览器/设备', value: item.browser });
            // perItem.push({ label: '版本号', value: item.versionName });
            perItem.push({ label: '创建人', value: item.modifyBy });
            return perItem;
        });
        const total = lodash.get(res, 'total');
        return {
            dataSource,
            total,
        };
    }
    /**
     * 协议列表
     */
    get protocolList() {
        return lodash.get(this.Model.value, 'protocolList') || [];
    }
    /**
     * 用户确认协议列表
     */
    get userLogList() {
        return lodash.get(this.Model.value, 'userLogList') || [];
    }
    /**
     * 获取协议列表
     * @memberof ProtocolController
     */
    async getProtocolList() {
        try {
            const res = await AjaxBasics.request({
                ...EnumAPI.legal_portal_protocol_list,
            });
            this.Model.merge({ protocolList: res });
            return res;
        }
        catch (error) {
            throw error;
        }
    }
    /**
     * 获取用户确认协议列表
     * @memberof ProtocolController
     */
    async getUserLogList() {
        try {
            const res = await AjaxBasics.request({
                ...EnumAPI.legal_portal_protocol_userLog_findForPage,
            });
            this.Model.merge({ userLogList: res });
            return res;
        }
        catch (error) {
            throw error;
        }
    }
    /**
     * 获取合作伙伴网络注册协议
     * @memberof ProtocolController
     */
    async getPartnerNetworkRegistrationAgreement() {
        try {
            const res = await AjaxBasics.request({
                ...EnumAPI.legal_portal_protocol_list,
            });
            return res;
        }
        catch (error) {
            throw error;
        }
    }
    /**
     * 获取用户登录记录列表搜索项：登录场景
     * @memberof ProtocolController
     */
    async getLoginRecordSence() {
        try {
            const res = await AjaxBasics.request({
                ...EnumAPI.login_record_sence,
            });
            return res;
        }
        catch (error) {
            throw error;
        }
    }
    /**
     * 获取用户登录记录列表搜索项：登录场景
     * @memberof ProtocolController
     */
    async getLoginRecordAgreementName() {
        try {
            const res = await AjaxBasics.request({
                ...EnumAPI.login_record_agreement,
            });
            return res;
        }
        catch (error) {
            throw error;
        }
    }
};
ProtocolController = __decorate([
    BindAll()
], ProtocolController);
export { ProtocolController };
